import React, { useContext } from "react";

import {
  timestampToLastUpdatedStr,
  nameToTitle,
} from "web_modules/capital_markets_dashboard/shared/utils";

import DataMatrix from "./DataMatrix";
import { RatesContext } from "../../RatesProvider";

const styles = require("./styles.module.scss");

interface Props {
  loanTypeName: string;
  editing: boolean;
}

const LtvAdjusters = ({ loanTypeName, editing }: Props) => {
  const { currentAdjusters, updatedAdjusters, editLtvAdjuster } = useContext(RatesContext);
  const { created_at, ltv_adjusters, ltv } = updatedAdjusters;

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{nameToTitle(loanTypeName)} LTV based rate adjusters (LLPAs)</h3>

      <div className={styles.updated}>{timestampToLastUpdatedStr(created_at)}</div>

      <DataMatrix
        xAxisLabels={ltv}
        xAxisTitle="LTV Range"
        prevMatrix={currentAdjusters.ltv_adjusters}
        matrix={ltv_adjusters}
        editMatrix={editLtvAdjuster}
        editing={editing}
      />
    </div>
  );
};

export default LtvAdjusters;
